import {
  DEFAULT_TYPEAHEAD_QUERY_LIMIT,
  DEFAULT_TYPEAHEAD_SORTING,
  DISPLAYED_LIST_TYPES,
  DISPLAYED_LIST_TYPES_FOR_SUBSCRIPTION_USER_LIST,
} from 'modules/queryBuilder/constants';
import { useMemo } from 'react';

export const useListsVariables = (search: string, page: number, excludeDynamicLists?: boolean) =>
  useMemo(
    () => ({
      search,
      pagination: {
        ...DEFAULT_TYPEAHEAD_QUERY_LIMIT,
        offset: DEFAULT_TYPEAHEAD_QUERY_LIMIT.limit * page,
      },
      sort: DEFAULT_TYPEAHEAD_SORTING,
      filterInfo: {
        listType: excludeDynamicLists
          ? DISPLAYED_LIST_TYPES_FOR_SUBSCRIPTION_USER_LIST
          : DISPLAYED_LIST_TYPES,
      },
    }),
    [search, page, excludeDynamicLists],
  );
